<template>
    <vx-alert :color="props.error.severity === 'warning' ? 'info' : 'danger'" :closeable="false">
        <template v-slot:icon>
            <font-awesome-icon
                :icon="props.error.severity === 'warning' ? faTriangleExclamation : faHexagonExclamation"
                widthAuto
            ></font-awesome-icon>
        </template>

        {{ props.error.message }}

        <template v-slot:right>
            <div class="flex-nowrap flex items-center gap-1">
                <vx-popover v-if="props.error.ai_agent" class="flex! [&>div]:flex!" hover arrow placement="top">
                    <vx-badge
                        size="2xs"
                        class="ml-1 whitespace-nowrap"
                        :color="props.error.severity === 'warning' ? 'info' : 'danger'"
                    >
                        AI <font-awesome-icon :icon="faSparkle" />
                    </vx-badge>
                    <template v-slot:content>
                        <div class="text-center">
                            <font-awesome-icon class="text-slate-400" :icon="faSparkle" /> {{ props.error.ai_agent }}
                        </div>
                    </template>
                </vx-popover>
                <vx-badge
                    v-if="!onCorporate()"
                    size="2xs"
                    class="ml-1 whitespace-nowrap"
                    :color="props.error.severity === 'warning' ? 'info' : 'danger'"
                >
                    Set by Corp <font-awesome-icon :icon="faCrown" />
                </vx-badge>
            </div>
        </template>
    </vx-alert>
</template>

<script setup lang="ts">
import { VxAlert, VxBadge, VxPopover } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation, faCrown, faHexagonExclamation, faSparkle } from '@fortawesome/pro-solid-svg-icons';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { type MessageStandardsError } from '~/constants/campaign';

const props = defineProps<{
    error: MessageStandardsError;
}>();

const { onCorporate } = useCurrentGroup();
</script>
